import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { PushConsent } from "@/components/PushConsent";
import { Bell, ChevronRight } from "lucide-react";

const fmt = (iso) => new Date(iso).toLocaleString("fr-FR", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export default function Notifications() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (loading) return;
    if (!user?.role) { navigate("/connexion"); return; }
    api.get("/notifications").then(({ data }) => { setItems(data); api.post("/notifications/read").catch(() => {}); });
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-10">
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-rose-brand mb-3"><Bell className="w-4 h-4" /> Messages importants</span>
        <h1 className="font-serif text-4xl sm:text-5xl text-olive">Mes notifications</h1>
        <div className="mt-6"><PushConsent compact /></div>
        <div className="mt-6 space-y-2" data-testid="notifications-list">
          {items.length === 0 && <p className="text-muted-foreground py-10 text-center" data-testid="notifications-empty">Aucune notification pour le moment. Vous retrouverez ici les infos de votre séjour.</p>}
          {items.map((n) => (
            <button key={n.notification_id} onClick={() => n.url && navigate(n.url)} className={`w-full text-left rounded-2xl border p-4 flex items-start gap-3 hover-lift ${n.read ? "bg-white border-border" : "bg-rosebrand-pale/40 border-rose-brand/30"}`} data-testid={`notification-${n.notification_id}`}>
              <span className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${n.read ? "bg-border" : "bg-rose-brand"}`} />
              <span className="flex-1 min-w-0">
                <span className="flex justify-between gap-3"><span className="font-semibold text-olive">{n.title}</span><span className="text-xs text-muted-foreground shrink-0">{fmt(n.created_at)}</span></span>
                <p className="text-sm text-foreground mt-0.5 whitespace-pre-line">{n.body}</p>
              </span>
              {n.url && <ChevronRight className="w-4 h-4 text-muted-foreground mt-1" />}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
